import React from "react";

// One route registry for browser loading and synchronous SEO rendering.
export default function createAppRoutes({ Home, Solutions, Services, Produits, Contact, UnderConstruction, Apropos, Carriere, DescriptionProduits, NotFound, Catalogues, CataloguesV2, VisualStockPage, VisualImmoPage, ServiceDetail, ProductDetailPage, SolutionDetailPage }) {
  const AppRoutes = [
  {
    index: true,
    element: <Home />,
  },
  {
    path: "solutions/gestion-des-inventaires",
    element: <SolutionDetailPage solutionKey="gestion-des-inventaires" />, // Add registration page route
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/*",
    element: <NotFound />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/telechargements",
    element: <Catalogues />,
  },
  {
    path: "/catalog",
    element: <CataloguesV2 />,
  },
  {
    path: "/produits",
    element: <Produits />,
  },
  {
    path: "solutions/distribution",
    element: <SolutionDetailPage solutionKey="distribution" />,
  },

  {
    path: "solutions/industrie",
    element: <SolutionDetailPage solutionKey="industrie" />,
  },
  {
    path: "solutions/logistique",
    element: <SolutionDetailPage solutionKey="logistique" />,
  },
  {
    path: "solutions/sante",
    element: <SolutionDetailPage solutionKey="sante" />,
  },
  {
    path: "/contactus",
    element: <Contact />,
  },
  {
    path: "solutions/banque",
    element: <SolutionDetailPage solutionKey="banque" />,
  },

  {
    path: "solutions/services-publics",
    element: <SolutionDetailPage solutionKey="services-publics" />,
  },
  {
    path: "/produits/imprimantes",
    element: <ProductDetailPage productKey="imprimantes" />,
  },

  {
    path: "/produits/scanners",
    element: <ProductDetailPage productKey="scanners" />,
  },
  {
    path: "/produits/terminaux-embarques",
    element: <ProductDetailPage productKey="terminaux-embarques" />,
  },
  {
    path: "/produits/terminaux-mobiles",
    element: <ProductDetailPage productKey="terminaux-mobiles" />,
  },
  {
    path: "/produits/logiciels",
    element: <ProductDetailPage productKey="logiciels" />,
  },
  {
    path: "/produits/tablettes-industrielles",
    element: <ProductDetailPage productKey="tablettes-industrielles" />,
  },
  {
    path: "/produits/infrastructure-wi-fi",
    element: <ProductDetailPage productKey="infrastructure-wi-fi" />,
  },
  {
    path: "/produits/consommables",
    element: <ProductDetailPage productKey="consommables" />,
  },
  {
    path: "/produits/terminaux-point-de-vente",
    element: <ProductDetailPage productKey="terminaux-point-de-vente" />,
  },
  {
    path: "/produits/bornes-interactives-kiosques",
    element: <ProductDetailPage productKey="bornes-interactives-kiosques" />,
  },
  {
    path: "/UnderConstruction",
    element: <UnderConstruction />,
  },
  {
    path: "/a-propos",
    element: <Apropos />,
  },
  {
    path: "/carriere",
    element: <Carriere />,
  },
  {
    path: "/produits/logiciels/Description",
    element: <DescriptionProduits />,
  },{
    path: "/visual-immo",
    element: <VisualImmoPage />,
  },
  {
    path: "/visual-stock",
    element: <VisualStockPage />,
  },
  {
    path: "/services/:slug",
    element: <ServiceDetail />,
  }
];

return AppRoutes;
}
